function getFirstAvailablePath() {
  const firstAvailablePage = JSON.parse(sessionStorage.getItem("userDetails"))[0].user_permissions.find((item) => item.status === 1);
  if (!firstAvailablePage) return "";

  return getPathByModuleId(firstAvailablePage.module_id);
}

function getPathByModuleId(moduleId) {
  switch (moduleId) {
    case 1:
      return "/dashboard/home";
    case 2:
      return "/dashboard/product";
    case 3:
      return "/dashboard/themes";
    case 4:
      return "/dashboard/users";
    case 5:
      return "/dashboard/zipcodes";
    case 6:
      return "/dashboard/videos";
    case 7:
      return "/dashboard/contact-us";
    case 8:
      return "/dashboard/services";
    case 9:
      return "/dashboard/questions";
    case 10:
      return "/dashboard/service-request";
    case 11:
      return "/dashboard/settings";
    case 12:
      return "/dashboard/help";
    case 13:
      return "/dashboard/mobile-configuration";
    case 14:
      return "/dashboard/signup";
    case 15:
      return "/dashboard/banks";
    default:
      return "";
  }
}

export { getFirstAvailablePath, getPathByModuleId };
